import React from 'react'

const NotFound = () => {
  return (
    <div className='d-flex justify-content-center align-items-center vh-100'>
      <div className="d-flex flex-column">
        <p className='error'>404 404 404 404 404 404 404 404 404 404 404</p>
        <h1 className='dash-title'>PÁGINA NÃO ENCONTRADA</h1>
        <p className='error'>404 404 404 404 404 404 404 404 404 404 404</p>
      </div>
    </div>
  )
}

export default NotFound